import { joinCn } from '../util';

const style = {
  vFileBrowserContainer: joinCn(
    'h-full w-full',
    'p-2',
    'bg-white',
    'text-body-m',
    'overflow-hidden',
  ),

  vFileBrowserContentList: joinCn('relative', 'h-full flex-1 overflow-hidden'),

  vFileBrowserContentListDragBox: joinCn(
    'absolute',
    'bg-secondary-300/10',
    'border border-secondary-300/50',
    'rounded-sm',
    'top-[var(--top)] left-[var(--left)] h-[var(--h)] w-[var(--w)]',
    'translate-x-[var(--tx)] translate-y-[var(--ty)]',
    'z-[1]',
  ),

  vFileBrowserTree: joinCn(
    'relative',
    'pr-2',
    'h-full w-[332px] !max-w-160 !min-w-[332px]',
    'overflow-hidden',
  ),

  vFileBrowserTreeResizer: joinCn(
    'absolute top-0 right-0 hover:-right-[1px]',
    'h-full w-[3px] hover:w-[5px]',
    'bg-transparent hover:bg-tertiary-200',
    'border-[1px] border-solid border-white',
    'transition-colors',
    'cursor-col-resize',
  ),
} as const;

export default style;
